import React from 'react';
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Popup from '../../../../Shared/Popup/PopUp';
import { goToPage, reportAnalytics } from '../../TechnicianUpdatesBlockSlice';

const CancelVisitPopUp = (props) =>  {

  useExtendedEffect((runSideEffects) => { 

    if (runSideEffects()) {
      props.reportAnalytics({eventCategory: 'technician_update', eventAction: "visibility_10", eventLabel: "element_12"});
    }
  }, []);


    return (
        <Popup className="technician-cancel-visit-popup" showPopUp={props.isShowCancelPopUp} onClose={() => {props.closeCancelVisitPopUp()}}>
            <h1>האם אתה בטוח <br/>שאתה רוצה לבטל?</h1>
            <p>התקלה סודרה או שאין לכם צורך בהגעת הטכנאי? <br/> לחצו על ביטול הגעת טכנאי</p>
            <div className="btn-wrapper">
                <button className="cancel-visit-popup-btn" onClick={() => {props.cancelVisitBtn()}}>כן, בטל</button>   
                <BtnSubmit onclick={() =>props.closeCancelVisitPopUp()} text="לא לבטל" formid="technician-cancel-visit-popup"></BtnSubmit>
            </div>
        </Popup>
    )
}

const mapStateToProps = (state) => {
    return {
        errorId : state.technicianUpdatesBlock.error.id,
        isShowCancelPopUp: state.technicianUpdatesBlock.isShowCancelPopUp,
    };
  };
  
  const mapDispatchToProps = {
    goToPage,
    reportAnalytics
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(CancelVisitPopUp);